import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const MenuRightIcon = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <Path
      stroke="#0058AD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="m10 17 5-5-5-5"
    />
  </Svg>
);
export default MenuRightIcon;
